module.exports = __webpack_public_path__ + "img/icon_fb.8c0e2be4.svg";